import { inject, Pipe, PipeTransform } from '@angular/core';
import { isEmpty } from '@maplecroft-typescript/utils';
import { WINDOW } from '../util';

@Pipe({
  name: 'assetsPath',
  pure: true,
  standalone: false,
})
export class AssetsPathPipe implements PipeTransform {
  private readonly window = inject(WINDOW);

  public transform(path: string | null): string | null {
    if (!path) {
      return path;
    }

    if (!/^\/?assets\//.exec(path)) {
      return path;
    }

    if (!this.window.location.pathname.includes('/branch/')) {
      return path;
    }

    const parts = path.split('/').filter((part) => !isEmpty(part));

    return this.window.location.pathname.split('/').slice(0, 3).concat(parts).join('/');
  }
}
